import trim from "lodash/trim";
import moment from "moment-timezone";
import { DATE_TIME_FORMATS } from "util/DateTime";
import { MISSING_BUCKET_NAME } from "views/Constants";
export const isPhrase = (searchTerm) => String(searchTerm).indexOf(" ") !== -1;
export const escape = (searchTerm) => {
  let escapedTerm = String(searchTerm);
  escapedTerm = escapedTerm.replace(/\r\n/g, " ");
  escapedTerm = escapedTerm.replace(/\n/g, " ");
  escapedTerm = escapedTerm.replace(/<br>/g, " ");
  if (isPhrase(escapedTerm)) {
    escapedTerm = String(escapedTerm).replace(/(["\\])/g, "\\$&");
    escapedTerm = `"${escapedTerm}"`;
  } else {
    escapedTerm = String(escapedTerm).replace(/(&&|\|\||[:\\/+\-!(){}[\]^"~*?$])/g, "\\$&");
  }
  return escapedTerm;
};
export const addToQuery = (oldQuery, newTerm, operator = "AND") => {
  if (trim(oldQuery) === "*" || trim(oldQuery) === "") {
    return newTerm;
  }
  if (trim(newTerm) === "*" || trim(newTerm) === "") {
    return oldQuery;
  }
  return `${oldQuery} ${operator} ${newTerm}`;
};
export const concatQueryStrings = (queryStrings, { operator = "AND", withBrackets = true } = {}) => {
  const withRemovedEmpty = queryStrings.filter((s) => !!(s == null ? void 0 : s.trim()));
  const showBracketsForChild = withBrackets && withRemovedEmpty.length > 1;
  return withRemovedEmpty.map((s) => showBracketsForChild ? `(${s})` : s).join(` ${operator} `);
};
export const formatTimestamp = (value) => {
  const utc = moment(value).tz("UTC");
  return `"${utc.format(DATE_TIME_FORMATS.internalIndexer)}"`;
};
export const predicate = (field, value) => value === MISSING_BUCKET_NAME || value === escape(MISSING_BUCKET_NAME) ? `NOT _exists_:${field}` : `${field}:${value}`;
export const not = (query) => `NOT ${query}`.replace(/^NOT NOT /, "");
export const edgeClause = (a, b) => {
  const pair = (v1, v2) => `${predicate(a.field, escape(v1))} AND ${predicate(b.field, escape(v2))}`;
  return `((${pair(a.value, b.value)}) OR (${pair(b.value, a.value)}))`;
};
